





























































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import UserInfo from "@/components/userInfo/userInfo.vue";
import ScrollView from "@/components/scroll/flipScroll.vue";
import * as types from "@/store/constants/types";
import SkuSection from "@/components/sku/skuSection.vue";
import Tab from "@/components/tab/Tab.vue";
import TabContent from "@/components/tab/TabContent.vue";
import GeneralUtilsHelper from "@/utils/generalUtils";
import Gallery from "@/components/popGallery/InsUserPopGallery.vue";
import { sendEvent } from "@/utils/analytics";
import { swiperSlide } from "vue-awesome-swiper";
import Swiper from "@/components/swiper/Swiper.vue";
import localStorageHelper from "@/localstorage/localstorage";
import CoinsTitleSeperator from "@/components/sku/coinsTitleSperator.vue";
import { CDN_BASE_URL } from "@/config/config";
import EventBus from "@/utils/eventBus";
import lazyLoad from "@/components/lazyLoad/lazyLoad.vue";
@Component({
  components: {
    Tab,
    TabContent,
    UserInfo,
    ScrollView,
    Gallery, //避免点击后有延迟才出现，改为同步加载
    SkuSection,
    Swiper,
    swiperSlide,
    lazyLoad,
    CoinsTitleSeperator,
    GoldenFollowerTip: () => import("./GoldenFollowerTip.vue"),
    EntranceBanner: () =>
      import("@/components/entranceBanner/EntranceBanner.vue"),
    SubsEntranceList: () =>
      import("@/components/entranceBanner/SubsEntranceList.vue"),
    SpecialOffer: () => import("@/components/specialOffer/SpecialOffer.vue"),
    BottomInfo: () => import("@/components/other/bottomInfo.vue"),
    QuestionEntrance: () => import("./QuestionEntrance.vue"),
    SuperPaySkuEntrance: () =>
      import("@/components/superPayEntrance/SuperPaySkuEntrance.vue")
  },
  name: "FollowersContainer"
})
export default class FollowersContainer extends Vue {
  @Getter(types.GETTER_CURRENT_INS_USER_INFO) private currentUserInfo: any;
  @Getter(types.GETTER_INS_USER_INFO_BY_ID) private getUserInfo: any;
  @Getter(types.GETTER_CURRENT_INS_USER_ID) private currentUserId: any;
  @Action(types.UPDATE_USER_INS_INFO) private updateUserInsInfo: any;
  @Action(types.DIALOG_SHOW) private dialogShow: any;
  @Action(types.ROUTER_PUSH) private routerPush: any;
  @Action(types.SHOW_LITE_SEARCH_OR_LOGIN) private showLoginOrSearch: any;
  @Getter(types.GETTER_SETTING_DATA) private settingData: any;
  @Getter(types.GETTER_MASTER_SERVICE_DATA) private gxUserInfo: any;
  @Action(types.PAY_BY_ANY) private payByAny: any;

  private galleryShow: boolean = false; //弹出的Gallery显示或隐藏

  private tabsArractiveIndex: number = 0;
  private vipDayNum: number = 0;
  private specialOfferForceShow: boolean = false; //是否强制显示special offer

  private subsEntranceShow: boolean = false; //默认是false

  private showActiveSecondIndexCache: boolean = false;

  private tabsArr: object[] = [
    {
      label: "Followers",
      labelColor: "#4f79ff",
      imgUrl: CDN_BASE_URL.img + "/tab/icon_followers2.png"
    },
    {
      label: "Golden Followers",
      labelColor: "rgb(250,185,5)",
      imgUrl: CDN_BASE_URL.img + "/tab/icon_golden_followers2.png"
    }
  ];

  @Watch("currentUserInfo", { immediate: true })
  private currentUserInfoChange(val: any, oldVal: any) {
    console.log("currentUserInfoChange:", {
      val,
      oldVal
    });
    if (val && val.hasOwnProperty("dataStatus") && val.dataStatus !== "ready") {
      console.log("watch到currentUserInfoChange不是准备状态，更新用户信息>>>", {
        val,
        oldVal
      });
      //TODO 并且要监听是否在当前路由下
      this.updateUserInsInfo({
        userId: this.currentUserId,
        username: this.currentUserInfo.userName
      })
        .then((result: any) => {})
        .catch(() => {});
    }
  }

  @Watch("tabsArractiveIndex", { immediate: true })
  private tabIndexChange(val: any, oldVal: any) {
    //监听如果切换到golden followers的话弹窗
    let goldenFollowersTabShowed: boolean = false;
    if (val && !goldenFollowersTabShowed) {
      if (localStorageHelper.has("golden_followers_tab_show")) {
        goldenFollowersTabShowed = true;
      } else {
        localStorageHelper.set("golden_followers_tab_show", true);
        goldenFollowersTabShowed = true;
        this.clickQuestionEntrance();
      }
    }
  }

  @Watch("$route", { immediate: true })
  private watchRoute(to: any, from: any) {
    const comeFromNotice = to.params.comeFromNotice;
    if (
      comeFromNotice &&
      (comeFromNotice === true || comeFromNotice === "true")
    ) {
      //表示点击通知进入，强制显示special offer
      this.specialOfferForceShow = true;
    }
  }

  private handler(component: any) {
    console.log("this component is showing");
  }

  private onPullingDown(done: any) {
    if (!this.isEmptyAccount) {
      this.updateUserInsInfo({
        userId: this.currentUserId,
        username: this.currentUserInfo.userName
      })
        .then((result: any) => {
          done();
        })
        .catch(() => {
          done();
        });
    } else {
      done();
    }
  }

  get isEmptyAccount() {
    return GeneralUtilsHelper.isEmptyAccount();
  }

  get showActiveSecondIndex() {
    if (this.tabsArractiveIndex === 1 || this.showActiveSecondIndexCache) {
      this.showActiveSecondIndexCache = true;
      return true;
    } else {
      return false;
    }
  }

  get currentType() {
    console.log("currentType:", this);
    switch (this.tabsArractiveIndex) {
      case 0:
        return "follow";
      case 1:
        return "goldenFollow";
      default:
        break;
    }
  }

  private clickUserInfo() {
    if (this.isEmptyAccount) {
      this.showLoginOrSearch();
    } else {
      this.galleryShow = true;
    }
  }

  private specialOfferShowOrHideTimer(val: boolean) {
    console.log("specialOfferShowOrHideTimer:", val);
    if (val) {
      //显示
      this.subsEntranceShow = false;
    } else {
      //隐藏
      this.subsEntranceShow = true;
    }
  }

  private async clickQuestionEntrance() {
    const followId = await this.dialogShow({
      title: "Followers Differences",
      midContent: (
        <div>
          <img
            src={require("@/assets/icons-file/dialog/pic_goldenfollowers_differences.png")}
          />
        </div>
      ),
      // tslint:disable-next-line:align
      buttons: [
        {
          text: "UNDERSTOOD"
        }
      ]
    });
    console.log("followId", followId);
  }

  private slideChange(index: any) {
    this.tabsArractiveIndex = index;
  }
  private mounted() {}
}
